import type { ReactNode } from "react";
import { useMemo } from "react";

import { createNodeTransientState } from "./NodeTransientState";
import { NodeTransientStateContext } from "./NodeTransientStateContext";

export const NodeTransientStateProvider = ({ children }: { children: ReactNode }) => {
  const value = useMemo(() => createNodeTransientState(), []);

  return <NodeTransientStateContext.Provider value={value}>{children}</NodeTransientStateContext.Provider>;
};
